module.exports = __webpack_public_path__ + "static/np-plan4-078df0ce72dae758d220a13a62976c0b.pdf";